import SpecialSalaryPatternPage from "./SpecialSalaryPatternPage";

export default SpecialSalaryPatternPage;
